module.exports = __webpack_public_path__ + "img/admin-miniprogram-qrcode.f54a178e.jpg";